import React, { useState } from 'react';
import { ASSETS } from '../../constants/assets';
import './PasswordInput.scss';

export interface PasswordInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  error,
  fullWidth = true,
  className = '',
  id,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputId = id || `password-input-${Math.random().toString(36).substr(2, 9)}`;
  const errorId = error ? `${inputId}-error` : undefined;

  const inputClasses = [
    'password-input',
    error && 'password-input--error',
    fullWidth && 'password-input--full-width',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="password-input-wrapper">
      {label && (
        <label htmlFor={inputId} className="password-input-label">
          {label}
        </label>
      )}
      <div className="password-input-field">
        <input
          id={inputId}
          type={showPassword ? 'text' : 'password'}
          className={inputClasses}
          aria-invalid={error ? true : undefined}
          aria-describedby={errorId}
          {...props}
        />
        <button
          type="button"
          className="password-input-toggle"
          onClick={() => setShowPassword(!showPassword)}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          <img
            src={showPassword ? ASSETS.icons.eyeOpen : ASSETS.icons.eyeClosed}
            alt={showPassword ? 'Hide password' : 'Show password'}
            width="20"
            height="20"
          />
        </button>
      </div>
      {error && (
        <span id={errorId} className="password-input-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

